/** Role of a user within a single organization (per-tenant). */
export enum OrgRole {
  ADMIN = 'ADMIN',
  FACILITATOR = 'FACILITATOR',
  LEADER = 'LEADER',
  GAMER = 'GAMER'
}

export type OrganizationMembership = {
  organizationId: string
  role: OrgRole
  joinedAt: string
  /** Stamped whenever `role` changes, so Aria can tell a participant who became a leader. */
  roleUpdatedAt?: string
}

/** Directory row returned by `getOrgMembers` (org role + user profile fields). */
export type OrgMemberRow = {
  userId: string
  displayName?: string
  email?: string
  role: OrgRole
  joinedAt: string
  /** Team ids from the user document (not stored on membership). */
  teamIds?: string[]
}

export type UpdateOrgMemberRequest = {
  organizationId: string
  userId: string
  patch: {
    role?: OrgRole
  }
}

/** Provision org membership by email without sending an invite email. */
export type CreateOrgMemberByEmailRequest = {
  organizationId: string
  email: string
  role: OrgRole
}

export type CreateOrgMemberByEmailResponse = {
  userId: string
}
